import React from 'react';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import { Box } from '@ublend-npm/aulaui-core';
import {
  SPACE_CARD_ICON_BUTTON_PADDING_PX,
  SPACE_CARD_ICON_BUTTON_RADIUS,
  SPACE_CARD_ICON_BUTTON_SIZE_PX,
  SPACE_CARD_ICON_GLYPH_COLOR,
  SPACE_CARD_ICON_GLYPH_SIZE_PX,
  SPACE_CARD_ICON_THUMBNAIL_BG,
} from './spaceWidgetConstants';

type SpaceCardBookIconProps = {
  backgroundColor?: string;
  glyphColor?: string;
};

/** Figma AutoStoriesOutlined icon button — 36×36, 100px radius, muted glyph on 12% white bg. */
const SpaceCardBookIcon = ({
  backgroundColor = SPACE_CARD_ICON_THUMBNAIL_BG,
  glyphColor = SPACE_CARD_ICON_GLYPH_COLOR,
}: SpaceCardBookIconProps) => (
  <Box
    aria-hidden
    className="space-card-book-icon"
    sx={{
      position: 'relative',
      width: SPACE_CARD_ICON_BUTTON_SIZE_PX,
      height: SPACE_CARD_ICON_BUTTON_SIZE_PX,
      borderRadius: SPACE_CARD_ICON_BUTTON_RADIUS,
      bgcolor: backgroundColor,
      p: `${SPACE_CARD_ICON_BUTTON_PADDING_PX}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      boxSizing: 'border-box',
      color: glyphColor,
    }}
  >
    <AutoStoriesOutlinedIcon
      sx={{
        width: SPACE_CARD_ICON_GLYPH_SIZE_PX,
        height: SPACE_CARD_ICON_GLYPH_SIZE_PX,
        fontSize: SPACE_CARD_ICON_GLYPH_SIZE_PX,
      }}
    />
  </Box>
);

export default SpaceCardBookIcon;
